import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.common.white,
    overflowX: 'hidden',
  },
}))

export default useStyles
